import React from 'react';

/** The website does not run the version check and does not mount this frame. */
export const AppUpdateScreen: React.FC = () => null;
